import React from "react";
import "./styles.scss";
import flyingImg from "./assets/flying.png";

export interface DashboardPageProps {}

const DashboardPage: React.FC<DashboardPageProps> = () => {
  return (
    <div className="box">
      <img src={flyingImg} alt="flying" />
    </div>
  );
};

export default DashboardPage;
